import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from "@angular/core";
import {Message, Participant, User} from "@twilio/conversations";
import {ChatService} from "../../services/chat.service";


require('./chat-conversation-message.scss');
@Component({
  standalone: false,
  selector: 'chat-conversation-message',
  templateUrl: './chat-conversation-message.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatConversationMessageComponent implements OnInit {

  @Input() message: Message;

  public currentUser: User;
  public participant: Participant;
  public user: User;
  public mediaUrl: string;
  public mediaContentType: string;
  public color: string;


  constructor(
    @Inject(ChatService) private chatService: ChatService,
    @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.currentUser = this.chatService.getCurrentUser();

    this._getParticipant();
    this._getMedia();
  }

  onViewImage(event, url: string) {
    // this.attachmentsDialog.imagesDialog(event, null, [url]);
  }

  private _getParticipant() {
    this.message.getParticipant()
      .then((participant: Participant) => {
        this.participant = participant;
        this._checkDetector();

        this._getUser();
      })
  }

  private _getUser() {
    this.participant.getUser()
      .then((user: any) => {
        this.user = user;
        this.color = this.chatService.getColorById(user.identity);
        this._checkDetector();
      })
  }

  private _getMedia() {
    const attachedMedia = this.message.attachedMedia;
    if (attachedMedia?.length) {
     attachedMedia[0].getContentTemporaryUrl()
       .then((mediaUrl: string) => {
         this.mediaUrl = mediaUrl;
         this.mediaContentType = attachedMedia[0].contentType;
         this._checkDetector();
       })
    }

  }

  private _checkDetector() {
    this.changeDetectorRef.detectChanges();
  }

}
